/* eslint-disable react-hooks/exhaustive-deps */
import { 	_,API, Constant, Http, Images, Utils } from "Helpers";
import React, { Fragment, useEffect, useState } from "react";
import {Modal, ModalHeader, ModalBody, Row, Col, Collapse } from "reactstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import { ReduxHOC } from "HOC";
import { SessionStorage } from "Helpers/Utilieties";
import {GameweekNativeSlider, Img} from "Components";
import { Trans } from "react-i18next";

const ConstestDetailModal = ({
	show, hideModal, root }) => {
    let current_date = "";
    let AppMasterData =  root.AppMasterData    
	const [selectedLeague, setSelectedLeague] = useState(null);
	const [selectedTab, setSelectedTab] = useState(1);
	const [contestPrizes, setcontestPrizes] = useState("");
    const [participants, setParticipants] = useState([]);
    const [selectedContest, setSelectedContest] = useState(null);
    const [weeklyPrizes, setWeeklyPrizes] = useState([]);
    const [posting, setPosting] = useState(false);
    const [FixturesList, setFixturesList] = useState([]);
	// const [isFromEnter, setisFromEnter] = useState(false);
    const [selectedWeek, setselectedWeek] = useState(null);
    const [hasMore, setHasMore] = useState(true);
    const [offset, setOffset] = useState(0);
    const [collapseBooster,setcollapseBooster] = useState(true)
    const [collapseGameRule,setcollapseGameRule] = useState(false)
    const [weekList, setWeekList] = useState([]);
    const [gameweeklastupdate, setGameweeklastupdate] = useState(
            new Date().valueOf()
    );
    const [CurrentFixtuerSelected, setCurrentFixtuerSelected] = useState('');
    const [MatchSummary, setMatchSummary] = useState(null);
    const [openingItem, setOpeningItem] = useState('');
    const [opening, setOpening] = useState(false);
    
    const generateWeeksArray = (start, end) => {
		const weeks = [];
		for (let i = Number(start); i <= Number(end); i++) {
			weeks.push({ week: i });
		}
		return weeks;
	};
    
   /*
	* When `show` becomes true we need to open the modal using data from
	* localStorage. The modal-opening logic is placed inline here so the
	* effect does not depend on a re-created callback (and avoids
	* react-hooks/exhaustive-deps warnings).
	*/
   // eslint-disable-next-line react-hooks/exhaustive-deps
   useEffect(() => {
	if (show) {
		const data = JSON.parse(localStorage.getItem('contestData')) || {};
		setSelectedContest(data);
		const leaguesDataAll = SessionStorage.get("allLeaguesSports");
		const LData = getLeagueFromContest(leaguesDataAll, data.sports_id, data.league_id);
		Utils.setMultiLeg(LData);
        

		const leagueData = leaguesDataAll?.leagues?.[data.sports_id]?.find(
			(league) => league.league_id === data.league_id
		);
		setSelectedLeague(leagueData);
		const weeksArray = generateWeeksArray(Number(data.start_week), Number(data.end_week));
		setWeekList(weeksArray);
		setselectedWeek(data.curentWeek ? data.curentWeek : data.start_week);
		CallPrizesApi(data);
		document.body.classList.add("background-freeze");
	} else {
		document.body.classList.remove("background-freeze");
	}
	
	return () => {
		document.body.classList.remove("background-freeze");
	};
   }, [show]);
  const stats = [
    {
      value: '2',
      label: 'Transfer per Week'
    },
    {
      value: '3',
      label: 'Max Player per Team'
    }
  ];
	const CallPrizesApi = (data) => {
		let param = {
			sports_id: data.sports_id,
			league_id: data.league_id,
			contest_id: data.contest_id,
		};
		Http.post(API.GET_PRIZES_CONTEST, param)
			.then((res) => {
				if (res?.response_code === Constant.SUCCESS_CODE) {
					if(!_.isNull(res.data)){
						let weekAll = res.data.weekly_prizes.sort((a, b) => parseInt(a.week) - parseInt(b.week));
						setWeeklyPrizes(weekAll)
						setcontestPrizes(res.data);
					}
				} else {
					console.error("Unexpected response:", res);
				}
			})
			.catch((error) => {
				console.error("Failed to fetch lobby contests:", error);
			});
	};
	const CallFixturesApi = (data) => {
        if(data !== null){
        setPosting(true);
		let param = {
			sports_id: data.sports_id,
			league_id: data.league_id,
			league_week: selectedWeek,
		};
		Http.post(API.GET_FIXTURE_LIST_CONTEST, param)
			.then((res) => {
				if (res?.response_code === Constant.SUCCESS_CODE) {
                    let match_list_clone = _.cloneDeep(res.data.match_list)
                    let match_list = {}
                    _.forEach(match_list_clone, (item, key) => {
                        if (_.isEmpty(match_list)) {
                        match_list = item
                        } else {
                        match_list = _.concat(match_list, item)
                        }
                    })
					setFixturesList(match_list);
					setPosting(false);
				} else {
					setPosting(false);
					console.error("Unexpected response:", res);
				}
			})
			.catch((error) => {
				setPosting(false);
				console.error("Failed to fetch lobby contests:", error);
			});
    }
	};
    const CallParticipantsApi = async (newOffset = 0, append = false,data) => {
    try {
      const param = {
        contest_id:data.contest_id,
        limit: "10",
        offset: newOffset.toString(),
      };
	  
      const res = await Http.post(API.GET_CONTEST_PARTICIPANTS, param);

      if (res?.response_code === Constant.SUCCESS_CODE) {
        const result = res?.data?.result || [];
        const apiOffset = res?.data?.offset ?? 0; // backend offset

        // ✅ Stop if no more data
        if (!result.length) {
          setHasMore(false);
          return;
        }

        if (append) {
          setParticipants((prev) => [...prev, ...result]);
        } else {
          setParticipants(result);
        }

        // ✅ Use API offset for next call
        setOffset(apiOffset);
		setHasMore(true);
      } else {
        console.error("Unexpected response:", res);
      }
    } catch (error) {
      console.error("Failed to fetch participants:", error);
    }
  };
	const handleClose = () => {
        setSelectedTab(1)
		setSelectedContest('');
		setSelectedLeague('');
		// setisFromEnter(false)
		setCurrentFixtuerSelected('');
		setMatchSummary(null);
		setOpeningItem('');
		setOpening(false);
		hideModal(false);
		document.body.classList.remove("background-freeze");
		// sendMessageToParent('show_header')
	};
	const changeTabId = (id) => {
		setSelectedTab(id);
		if (id === 3) {
			setParticipants([]);
			CallParticipantsApi(0, true, selectedContest);
		}
		if (id === 2) {
			CallFixturesApi(selectedContest);
		}
		if (id === 0) {
			CallPrizesApi(selectedContest);
		}
	};
    const fetchMore = () => {
		CallParticipantsApi(offset, true , selectedContest);
	};
    
    const getAllowedBoosters = (boosterList = [], allowedBoostersStr = '') => {
	if (!allowedBoostersStr || typeof allowedBoostersStr !== 'string') return [];

	const allowedTypes = allowedBoostersStr.split(',').map(Number);
	return boosterList.filter(booster => allowedTypes.includes(booster.type));
   };
   const getLeagueFromContest =(data, sportsId, leagueId)=>{
		const leaguesDataAll = SessionStorage.get("allLeaguesSports");
        
		//return
			// Find the sport by sportsId
			const sport = leaguesDataAll.sports.find((sport) => sport.sports_id === sportsId);
			if (!sport) {
				return `No sport found with ID: ${sportsId}`;
			}
		
			// Check if leagues exist for the given sportsId
			const leaguesForSport = leaguesDataAll.leagues[sportsId];
			if (!leaguesForSport) {
				return `No leagues found for sports ID: ${sportsId}`;
			}
		
			// Find the league by leagueId
			const league = leaguesForSport.find((league) => league.league_id === leagueId);
			if (!league) {
				return `No league found with ID: ${leagueId} for sports ID: ${sportsId}`;
			}
		
			// Return both sport and league data
			return { ...sport, ...league };
	}
const getWeekName = (item) => {
  const leaguesDataAll = SessionStorage.get("allLeaguesSports");
  const LData = getLeagueFromContest(leaguesDataAll, item.sports_id, item.league_id);
  
  const startWeekName = LData?.week_abbr?.[item.start_week] || "";
  const endWeekName = LData?.week_abbr?.[item.end_week] || "";

  return `${startWeekName} - ${endWeekName}`;
};
	const SelectWeekHandle = (data) => {
		
        setselectedWeek(data.week)
        setGameweeklastupdate(new Date().valueOf());
       CallFixturesApi(selectedContest);
	};
const toggleBooster =()=>{
		setcollapseBooster(!collapseBooster)
	}
	
	const toggleGameRule =()=>{
		setcollapseGameRule(!collapseGameRule)
	}

	const isMatchSummaryEmpty = (matchSummary) => {
		if (selectedContest && selectedContest.sports_id === 15) {
			return !matchSummary || !Array.isArray(matchSummary) || matchSummary.length === 0;
		}
		return true;
	};

	const toggleFixtureDetail = (item) => {
		if (CurrentFixtuerSelected !== item.season_game_uid) {
			let param = {
				"league_id": selectedContest.league_id,
				"sports_id": selectedContest.sports_id,
				"season_game_uid": item.season_game_uid
			};
			setOpeningItem(item.season_game_uid);
			setOpening(true);

			Http.post(API.GET_MATCH_SUMMARY, param).then(response => {
				const matchSummary = response.data.match_summary;
				setMatchSummary(matchSummary);
				setOpeningItem('');
				setOpening(false);
				if (isMatchSummaryEmpty(matchSummary)) {
					setCurrentFixtuerSelected('');
					Utils.notify(Constant.MSZ_FIXTURE_NOT_FOUND);
				} else {
					setCurrentFixtuerSelected(item.season_game_uid);
				}
			}).catch(error => {
				setOpening(false);
				setOpeningItem('');
				console.error(error);
			});
		} else {
			setCurrentFixtuerSelected('');
		}
	};

	const getPrizeDisplayValue = (prizeItem, parentPrizeValueType) => {
		const prizeValueType = String(prizeItem?.prize_value_type ?? parentPrizeValueType ?? "");
		if (String(prizeItem?.prize_type) === "3") {
			return String(prizeItem?.en_name || "");
		}
		if (prizeValueType === "1") {
			const rawValue = Number(prizeItem?.min_value ?? prizeItem?.amount ?? prizeItem?.value ?? 0);
			const minRank = Number(prizeItem?.min ?? 0);
			const maxRank = Number(prizeItem?.max ?? minRank);

			if (minRank < maxRank) {
				const rangeCount = (maxRank - minRank) + 1;
				return formatUpToTwoDecimals(rawValue / rangeCount);
			}

			return formatUpToTwoDecimals(rawValue);
		}
		return formatUpToTwoDecimals(prizeItem?.value ?? prizeItem?.amount ?? "");
	};

	const formatUpToTwoDecimals = (value) => {
		const numeric = Number(value);
		if (!Number.isFinite(numeric)) {
			return String(value ?? "");
		}
		return numeric.toFixed(2).replace(/\.?0+$/, "");
	};

	const getContestSizeMeta = () => {
		const minSize = Number(contestPrizes?.min_size ?? 0);
		const maxSize = Number(contestPrizes?.max_size ?? 0);
		const totalJoined = Number(contestPrizes?.total_user_joined ?? 0);
		return { minSize, maxSize, totalJoined };
	};

	const getEffectiveJoinedCount = () => {
		const { minSize, maxSize, totalJoined } = getContestSizeMeta();
		let joined = totalJoined === 0 ? minSize : totalJoined;
		if (maxSize > 0) {
			joined = Math.min(joined, maxSize);
		}
		return joined;
	};

	const getPrizeRankLabel = (prizeItem, parentPrizeValueType) => {
		const prizeValueType = String(prizeItem?.prize_value_type ?? parentPrizeValueType ?? "");
		const minRank = Number(prizeItem?.min ?? 0);
		const maxRank = Number(prizeItem?.max ?? minRank);
		const joined = getEffectiveJoinedCount();

		if (prizeValueType === "1" && minRank < maxRank && joined >= minRank && maxRank > joined) {
			return minRank === joined ? String(minRank) : `${minRank} - ${joined}`;
		}

		return minRank === maxRank ? String(minRank) : `${minRank} - ${maxRank}`;
	};

	const shouldShowPrizeRow = (prizeItem, parentPrizeValueType) => {
		const prizeValueType = String(prizeItem?.prize_value_type ?? parentPrizeValueType ?? "");
		if (prizeValueType !== "1") {
			return true;
		}

		const minRank = Number(prizeItem?.min ?? 0);
		const joined = getEffectiveJoinedCount();
		return joined >= minRank;
	};

	return (
		<Modal
			isOpen={show}
			toggle={handleClose}
			className="league-detail-modal modal-top"
		>
			{selectedContest && selectedLeague && 
			<ModalHeader>
				<div onClick={handleClose} className="close-btn">
					<i className="icon-cancel" />
				</div>
				<div className="title-modal">{selectedContest.contest_name}</div>
				<div className="contest-week">
					{selectedLeague.league_name}
					 
				</div>
			</ModalHeader>}
			{selectedContest && selectedLeague && 
			<ModalBody>
				<div className="tabs-wrap">
					<div
						className={`selection-tab ${selectedTab === 0 ? "selected" : ""}`}
						onClick={() => {
							changeTabId(0);
						}}
					>
						Prizes
					</div>
					<div
						className={`selection-tab ${selectedTab === 1 ? "selected" : ""}`}
						onClick={() => {
							changeTabId(1);
						}}
					>
						Rules
					</div>
					<div
						className={`selection-tab ${selectedTab === 2 ? "selected" : ""}`}
						onClick={() => {
							changeTabId(2);
						}}
					>
						Fixtures
					</div>
					<div
						className={`selection-tab ${selectedTab === 3 ? "selected" : ""}`}
						onClick={() => {
							changeTabId(3);
						}}
					>
						Entries
					</div>
				</div>
				<div className="tab-content">
					{selectedTab === 0 && (
						<div className="body-height-confimation">
							<div className="prizes-display">
								<div className="prize-title">
									<span>All Prizes</span>
								</div>
								<div className="prize-list">
									<table className="table-prize">
										<tbody>
											{contestPrizes.prize_distribution_detail &&
												contestPrizes.prize_distribution_detail
													.filter((prizeRow) => shouldShowPrizeRow(prizeRow, contestPrizes?.prize_value_type))
													.map(
													(item, index) => (
														<tr key={index}>
															<td className="left">
																{getPrizeRankLabel(item, contestPrizes?.prize_value_type)}
															</td>
															<td className="right">
																{String(item.prize_type) === "0" ||
																String(item.prize_type) === "1" ? (
																	<div>{`${AppMasterData.CURRENCY_CODE} ${getPrizeDisplayValue(item, contestPrizes?.prize_value_type)}`}</div>
																) : (
																	<div className="coin-wrap">
																		{String(item.prize_type) === "2" && (
																			<img
																				className="coin-img"
																				src={Images.IC_COIN}
																				alt="coin"
																			/>
																		)}
																		{getPrizeDisplayValue(item, contestPrizes?.prize_value_type)}
																	</div>
																)}
															</td>
														</tr>
													)
												)}
										</tbody>
									</table>
								</div>
							</div>
							<div className="prizes-display">
								{_.map(weeklyPrizes, (item, index) => {
									return (
										<>
											<div className="prize-title">
												<span>{selectedLeague.week_label[item.week]} </span>
											</div>
											<div className="prize-list">
												<table className="table-prize">
													<tbody>
														{item.prize &&
															item.prize
																.filter((prizeRow) => shouldShowPrizeRow(prizeRow, contestPrizes?.prize_value_type))
																.map((item, index) => (
																<tr key={index}>
																	<td className="left">
																		{getPrizeRankLabel(item, contestPrizes?.prize_value_type)}
																	</td>
																	<td className="right">
																		{String(item.prize_type) === "0" || String(item.prize_type) === "1"
																			? `${AppMasterData.CURRENCY_CODE} ${getPrizeDisplayValue(item, contestPrizes?.prize_value_type)}`
																			: getPrizeDisplayValue(item, contestPrizes?.prize_value_type)}
																	</td>
																</tr>
																))}
													</tbody>
												</table>
											</div>
										</>
									);
								})}
							</div>
						</div>
					)}
					{selectedTab === 1 && (
						<div className="body-height-confimation">
							<div className="rules-wraper">
								{/* <div className="rules-header">
											Season Long
											<span>Scoring & Rules</span>
										</div> */}
								<div className="rules-team-detail">
									<div className="rules-team-data">
										<div className={`rules-team-view ${selectedLeague && selectedLeague.bench_size === 0 ? 'full' : ''}`}>
											<div className="count-team">
												{Utils.getMultiLeg()?.team_player_count}
											</div>
											<div className="text-view-team">Starting player</div>
										</div>
										{selectedLeague && selectedLeague.bench_size > 0 && (
											<div className="rules-team-view l-theme">
												<div className="count-team">
													{selectedLeague?.bench_size}
												</div>
												<div className="text-view-team">Bench Players</div>
											</div>
										)}
									</div>
									<div className="rules-team-data">
										<div className="rules-team-view full">
											<div className="count-team">
												{getWeekName(selectedContest)}
											</div>
											<div className="text-view-team">Duration</div>
										</div>
									</div>
									<div
										className={`booster-container ${
											_.isEmpty(
												getAllowedBoosters(
													AppMasterData.booster_list,
													selectedContest.allowed_boosters
												)
											)
												? "empty"
												: ""
										}`}
									>
										{!_.isEmpty(
											getAllowedBoosters(
												AppMasterData.booster_list,
												selectedContest.allowed_boosters
											)
										) && (
											<div className="booster-section">
												<h2 className="section-title">Booster</h2>
												<div className="boosters-grid">
													{getAllowedBoosters(
														AppMasterData.booster_list,
														selectedContest.allowed_boosters
													).map((booster) => (
														<div key={booster.id} className="booster-card">
															<div className="booster-icon">
																<img
																	src={Images[`BOOSTER_${booster.type}`]}
																	width={24}
																	height={24}
																	alt={booster.name}
																/>
															</div>
															<h3 className="booster-name">{booster.label}</h3>
														</div>
													))}
												</div>
											</div>
										)}

										<div className="stats-section">
											{stats.map((stat, index) => (
												<div key={index} className="stat-card">
													<div className="stat-value">{stat.value}</div>
													<div className="stat-label">{stat.label}</div>
												</div>
											))}
										</div>
									</div>

									{/* <div className="rules-team-captain">
												<div className="rules-points">C</div>
												<div className="rules-points-txt">Captain to get 2X points for the player.</div>
											</div>
											<div className="rules-team-captain vc">
												<div className="rules-points">VC</div>
												<div className="rules-points-txt">Vice-Captian earns double points if the Captain doesn't play.</div>
											</div> */}
								</div>
								<>
									{selectedContest.sports_id === 15 ? (
										<>
											{/* MOTORSPORTS */}
											<div className="rules-sub-header wot">Help & Rules</div>
											<div
												className="rules-sub-header"
												onClick={() => toggleBooster()}
											>
												<span>Boosters</span>
												{collapseBooster ? (
													<i className="icon-up"></i>
												) : (
													<i className="icon-down"></i>
												)}
											</div>
											<Collapse isOpen={collapseBooster}>
												<div className="rules-sub-body">
													<span className="rules-color-head c1">
														Bench Boost
													</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															The points scored by your bench players in the
															next Gameweek are included in your total.
														</p>
													</div>
													<span className="rules-color-head c2">Free Hit</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															Free Hit booster lets you make unlimited transfers
															that are applied to one gameweek only. At the next
															deadline, the original squad is returned.
														</p>
													</div>
													<span className="rules-color-head c3">
														Triple Captain
													</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															Your captain points are tripled instead of doubled
															in the next Gameweek.
														</p>
													</div>
													<span className="rules-color-head c4">Wildcard</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															The transfers (including those already made) in
															the Gameweek are free of charge.
														</p>
													</div>
												</div>
											</Collapse>
											{
												<div
													className="rules-sub-header"
													onClick={() => toggleGameRule()}
												>
													<span>Game Rules</span>
													{collapseGameRule ? (
														<i className="icon-up"></i>
													) : (
														<i className="icon-down"></i>
													)}
												</div>
											}
											<Collapse isOpen={collapseGameRule}>
												<div className="rules-sub-body">
													<span className="rules-color-head c5">Scoring</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															Points will be awarded/deducted based on the Driver/Constructor's performance at the Grand Prix. Drivers points are awarded based on final race position.
														</p>
														<p className="rules-txt">
															Constructors earn combined points from both drivers' performances.
														</p>
													</div>
													<span className="rules-color-head c4">Tie Breakers</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															If users have equal points, rankings are decided based on Higher Main Race points &gt; Higher Qualifying points &gt; Earlier team submission time
														</p>
													</div>
													<span className="rules-color-head c2">
														Auto-Substitution
													</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															If any of your starting players (drivers) do not participate in the race or sprint, available bench players will automatically replace them based on the bench priority order. Auto substitutions are processed at the end of the gameweek.
														</p>
													</div>
												</div>
											</Collapse>
										</>
									) : selectedContest.sports_id !== "7" ? (
										<>
											<div className="rules-sub-header wot">Help & Rules</div>
											<div
												className="rules-sub-header"
												onClick={() => toggleBooster()}
											>
												<span>Boosters</span>
												{collapseBooster ? (
													<i className="icon-up"></i>
												) : (
													<i className="icon-down"></i>
												)}
											</div>
											<Collapse isOpen={collapseBooster}>
												<div className="rules-sub-body">
													<span className="rules-color-head c1">
														Bench Boost
													</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															The points scored by your bench players in the
															next Gameweek are included in your total.
														</p>
													</div>
													<span className="rules-color-head c2">Free Hit</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															Free Hit booster lets you make unlimited transfers
															that are applied to one gameweek only. At the next
															deadline, the original squad is returned.
														</p>
													</div>
													<span className="rules-color-head c3">
														Triple Captain
													</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															Your captain points are tripled instead of doubled
															in the next Gameweek.
														</p>
													</div>
													<span className="rules-color-head c4">Wildcard</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															The transfers (including those already made) in
															the Gameweek are free of charge.
														</p>
													</div>
												</div>
											</Collapse>
											{
												<div
													className="rules-sub-header"
													onClick={() => toggleGameRule()}
												>
													<span>Game Rules</span>
													{collapseGameRule ? (
														<i className="icon-up"></i>
													) : (
														<i className="icon-down"></i>
													)}
												</div>
											}
											<Collapse isOpen={collapseGameRule}>
												<div className="rules-sub-body">
													<span className="rules-color-head c5">Red Cards</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															If a player receives a red card, they will
															continue to be penalized for goals conceded by
															their team.
														</p>
														<p className="rules-txt">
															Red card deductions include any points deducted
															for yellow cards.
														</p>
													</div>
													<span className="rules-color-head c4">Assists</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															Points are awarded for assists based on our stats
															provider; Assists are awarded to a player who
															makes the final pass or cross before a goal is
															scored.
														</p>
														<p className="rules-txt">
															An assist is given even if the pass is
															unintentional, as long as it's the final one
															before the goal is scored; deflections & blocks
															would result in no assist being provided.
														</p>
													</div>
													<span className="rules-color-head c3">Own Goals</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															If a player shoots or passes the ball and forces
															an opposing player to put the ball in his own net,
															then an assist is awarded.
														</p>
													</div>
													<span className="rules-color-head c2">Penalties</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															In the case of a penalty, an assist is calculated
															for the player earning the penalty if a goal is
															scored. But not if the player played it himself,
															in that case the assist is not counted.
														</p>
													</div>
													<span className="rules-color-head c2">
														Auto Substitutions
													</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															If any of your starting players don't play any
															minutes in a gameweek, we will automatically
															substitute players from your bench to replace
															them. Auto substitutions are processed at the end
															of each gameweek.
														</p>
														<p className="rules-txt">
															If any of your players play 0 minutes in a
															gameweek, he will be substituted by the highest
															priority substitute bench player who played in
															that gameweek and does not break the original
															formation rule of creating teams. Points scored by
															your bench players during that gameweek will be
															added to your score.
														</p>
													</div>
												</div>
											</Collapse>
										</>
									) : (
										<>
											{/* CRICKET */}
											<div className="rules-sub-header wot">Help & Rules</div>
											<div
												className="rules-sub-header"
												onClick={() => toggleBooster()}
											>
												<span>Boosters</span>
												{collapseBooster ? (
													<i className="icon-up"></i>
												) : (
													<i className="icon-down"></i>
												)}
											</div>
											<Collapse isOpen={collapseBooster}>
												<div className="rules-sub-body">
													<span className="rules-color-head c1">
														Bench Boost
													</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															The points scored by your bench players in the
															next Round are included in your total.
														</p>
													</div>
													<span className="rules-color-head c2">Free Hit</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															Free Hit booster lets you make unlimited transfers
															that are applied to one round only. At the next
															deadline, the original squad is returned.
														</p>
													</div>
													<span className="rules-color-head c3">
														Triple Captain
													</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															Your captain points are tripled instead of doubled
															in the next round.
														</p>
													</div>
													<span className="rules-color-head c4">Wildcard</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															The transfers (including those already made) in
															the round are free of charge.
														</p>
													</div>
												</div>
											</Collapse>
											{
												<div
													className="rules-sub-header"
													onClick={() => toggleGameRule()}
												>
													<span>Game Rules</span>
													{collapseGameRule ? (
														<i className="icon-up"></i>
													) : (
														<i className="icon-down"></i>
													)}
												</div>
											}
											<Collapse isOpen={collapseGameRule}>
												<div className="rules-sub-body">
													<span className="rules-color-head c5">
														Scoring Rules
													</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															Earn points based on player performances across
															batting, bowling, and fielding. Runs, wickets,
															catches, and milestones add to your score, while
															bonuses and penalties for strike rate and economy
															make every performance count.
														</p>
													</div>

													<span className="rules-color-head c2">
														Auto Substitutions
													</span>
													<div className="rules-txt-wrap">
														<p className="rules-txt">
															If any of your starting players don’t play any
															minutes in a round, we will automatically
															substitute players from your bench to replace
															them. Auto substitutions are processed at the end
															of each round.
														</p>
														<p className="rules-txt">
															If any of your players play 0 minutes in a round,
															he will be substituted by the highest priority
															substitute bench player who played in that round
															and does not break the original formation rule of
															creating teams. Points scored by your bench
															players during that round will be added to your
															score.
														</p>
													</div>
												</div>
											</Collapse>
										</>
									)}
								</>
							</div>
						</div>
					)}
					{selectedTab === 2 && (
						<>
							<div className="body-height-confimation fixture-popup">
								<div className="native-slider-wrap">
									{selectedWeek && weekList.length > 0 && (
										<GameweekNativeSlider
											key={`fixture-slider-${selectedWeek}-${weekList.length}`}
											{...{
												scoring_weeks: weekList,
												SelectedWeek: selectedWeek,
												gameweeklastupdate,
												SelectWeekHandle: SelectWeekHandle,
												is_fixture: true,
												selectedLeague: selectedLeague,
											}}
										/>
									)}
								</div>
								<div className="self-block m-spc">
									{/* <Row>
                                                <Col>
                                                    <div className="weeek-block">
                                                        {Utils.getMultiLeg().week_label[selectedWeek]} 
														{selectedLeague.week_label[selectedWeek]}
                                                    </div>
                                                </Col>
                                            </Row> */}
									<Row className="pfix-row">
										{!posting ? (
											<Col className="fixtures-list-wrap mobile-fix myOverride">
												<div></div>
												<div className="fixtures-list">
													{_.map(FixturesList, (item, index) => {
														let firstChar = Utils.getUtcToLocal(
															item.season_scheduled_date,
															"dddd, MMM D"
														);
														let ShowHeadShow = false;
														if (firstChar !== current_date) {
															current_date = firstChar;
															ShowHeadShow = true;
														}
														return (
															<Fragment key={index}>
																{ShowHeadShow && firstChar !== "" && (
																	<div className="fixture-header">
																		<span>{firstChar}</span>
																	</div>
																)}

																{
																	selectedContest && selectedContest.sports_id === 15 ? (
																		<>
																			<div 
																				className={`fixture-item motorsport-item${item.season_game_uid ===CurrentFixtuerSelected && !isMatchSummaryEmpty(MatchSummary) ? ' active' : ''}${item.season_game_uid === openingItem ? ' opening' : ''}`} 
																				onClick={(!opening && Utils.isDateTimePast(item.season_scheduled_date, item)) ? () => toggleFixtureDetail(item) : null}
																			>
																				<div className={`cell mid motorsports-cell`}>
																					<div className='league-name'>{item.tournament_name}</div>
																				</div>
																				<div className={`right-cell ${item.season_game_uid === CurrentFixtuerSelected ? "selected" : ""}`}>
																					<i className={`icon-down ${item.season_game_uid ===CurrentFixtuerSelected ? 'icon-up' : ''}`}/>
																				</div>
																			</div>
																			{item.season_game_uid === CurrentFixtuerSelected && !isMatchSummaryEmpty(MatchSummary) && (
																				<div className='game-details motorsports-leaderboard'>
																					<div className="motorsports-table">
																						<div className="table-header">
																							<div className="col pos">Pos.</div>
																							<div className="col driver">Driver</div>
																							<div className="col team">Team</div>
																							<div className="col laps">Laps</div>
																							<div className="col time">Time / Retired</div>
																							<div className="col points">Points</div>
																						</div>
																						<div className="table-body">
																							{_.map(MatchSummary, (leaderItem, idx) => {
																								return (
																									<div className="table-row" key={idx}>
																										<div className="col pos">{leaderItem.f_position}</div>
																										<div className="col driver">
																											{leaderItem.jersey && (
																												<Img 
																													src={Utils.playerJersyUrl(leaderItem.jersey)} 
																													fallbacksrc={Images.DEFAULT_JERSEY} 
																													alt="" 
																													className="driver-icon"
																												/>
																											)}
																											<span className="driver-name">{leaderItem.full_name}</span>
																										</div>
																										<div className="col team">
																											{leaderItem.flag && (
																												<Img 
																													src={Utils.teamFlagUrl(leaderItem.flag)} 
																													fallbacksrc={Images.DEFAULT_FLAG} 
																													alt="" 
																													className="team-icon"
																												/>
																											)}
																											<span className="team-name">{leaderItem.team_name}</span>
																										</div>
																										<div className="col laps">{leaderItem.f_laps}</div>
																										<div className="col time">{leaderItem.f_time}</div>
																										<div className="col points">{leaderItem.fantasy_score}</div>
																									</div>
																								);
																							})}
																						</div>
																					</div>
																				</div>
																			)}
																		</>
																	) : (
																		<>
																			<div className={`fixture-item`}>
																				<div className="cell">
																					<div
																						{...{
																							className: `fx-name ${
																								Number(item.home_team_goal) >
																									Number(item.away_team_goal) ||
																								Number(item.home_team_score) >
																									Number(item.away_team_score)
																									? "winner"
																									: ""
																							}`,
																						}}
																						title={item.home_team_name}
																					>
																						<span className="web-l-name">
																							{item.home_team_name}
																						</span>
																						<span className="mob-l-name">
																							{item.home}
																						</span>
																					</div>
																					<figure className="fx-flag">
																						<Img
																							src={item.flag_home}
																							fallbacksrc={Images.DEFAULT_FLAG}
																							alt=""
																						/>
																					</figure>
																				</div>

																				<div
																					className={`cell mid ${
																						item.home_team_goal ? "" : " cricket"
																					}`}
																				>
																					<div className="score-capsule schedule-update">
																						{Utils.isDateTimePast(
																							item.season_scheduled_date,
																							item
																						) ? (
																							item.home_team_goal ? (
																								<div className="point-section">
																									<span>
																										{item.home_team_goal}
																									</span>
																									<div className="seprator" />
																									<span>
																										{item.away_team_goal}
																									</span>
																								</div>
																							) : (
																								<div className="point-section cricket">
																									<span>
																										<span>
																											<div className="crick-score-wrapper cricket-left">
																												<span className="score">
																													{item.home_team_score}/
																													{item.home_wickets}
																												</span>{" "}
																												<span className="overs">
																													({item.home_overs})
																												</span>
																											</div>
																										</span>
																									</span>
																									<div className="seprator" />
																									<span>
																										<div className="crick-score-wrapper cricket-right">
																											<span className="score">
																												{item.away_team_score}/
																												{item.away_wickets}
																											</span>{" "}
																											<span className="overs">
																												({item.away_overs})
																											</span>
																										</div>
																									</span>
																								</div>
																							)
																						) : (
																							<>
																								<img
																									src={Images.CLOCK_FMT}
																									alt=""
																								/>
																								{Utils.DateFormat(
																									Utils.getUtcToLocal(
																										item.season_scheduled_date
																									),
																									"HH:mm"
																								)}
																							</>
																						)}
																					</div>
																				</div>
																				<div className="cell last">
																					<figure className="fx-flag">
																						<Img
																							src={item.flag_away}
																							fallbacksrc={Images.DEFAULT_FLAG}
																							alt=""
																						/>
																					</figure>
																					<div
																						{...{
																							className: `fx-name ${
																								Number(item.home_team_goal) <
																									Number(item.away_team_goal) ||
																								Number(item.home_team_score) <
																									Number(item.away_team_score)
																									? "winner"
																									: ""
																							}`,
																						}}
																						title={item.away_team_name}
																					>
																						<span className="web-l-name">
																							{item.away_team_name}
																						</span>
																						<span className="mob-l-name">
																							{item.away}
																						</span>
																					</div>
																				</div>
																			</div>
																		</>
																	)
																}
															</Fragment>
														);
													})}
												</div>
											</Col>
										) : (
											<Utils.Spinner />
										)}
									</Row>
								</div>
							</div>
						</>
					)}
					{selectedTab === 3 &&
						(!_.isEmpty(participants) ? (
							<div className="entries-wrap" id="scrollableDiv">
								{participants.length > 0 && (
									<div className="entries-title">
										{`${participants.length} Entr${
											participants.length > 1 ? "ies" : "y"
										}`}
									</div>
								)}
								<div>
									<InfiniteScroll
										dataLength={participants.length} // length of current data
										next={fetchMore} // function to load more data
										hasMore={hasMore} // true/false for more data
										//loader={<h4>Loading...</h4>}     // loader while fetching
										scrollableTarget="scrollableDiv"
									>
										<div>
											{participants.length > 0
												? participants.map((itm, idx) => (
														<div className="entries-card" key={idx}>
															<div className="name-img-block">
																<div className="entry-img">
																	<img
																		src={itm.user_image || Images.DEFAULT_IMG}
																		alt="entry"
																		 onError={(e) => {
																																	e.target.onerror = null; 
																																	e.target.src =Images.DEFAULT_IMG; // your fallback image path
																																}}
																	/>
																</div>
																<div className="user-name">{itm.user_name}</div>
															</div>
														</div>
												  ))
												: "No Entries"}
										</div>
									</InfiniteScroll>
								</div>
							</div>
						) : (
							<div className="text-center body-height-confimation fixture-popup">
								<img
									className="n-image-modal"
									src={Images.EMPTY_LANDING}
									alt=""
								/>
								<h4 className="n-text-modal">No entries yet</h4>
							</div>
						))}
				</div>
				{String(contestPrizes?.prize_value_type) === "1" && (
					<div className="prize-note-footer text-center mb-3">
						<Trans>PRIZES_INCREASE_NOTE</Trans>
					</div>
				)}
			</ModalBody>}
		</Modal>
	);
};

export default ReduxHOC(ConstestDetailModal);
